// source: proto/reportpb/balance.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_type_date_pb = require('../../google/type/date_pb.js');
goog.object.extend(proto, google_type_date_pb);
var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js');
goog.object.extend(proto, proto_utilspb_pagination_pb);
goog.exportSymbol('proto.reportpb.Balance', null, global);
goog.exportSymbol('proto.reportpb.DashboardBalance', null, global);
goog.exportSymbol('proto.reportpb.ListBalanceRequest', null, global);
goog.exportSymbol('proto.reportpb.ListBalanceResponse', null, global);
goog.exportSymbol('proto.reportpb.ListCashBalanceSummary', null, global);
goog.exportSymbol('proto.reportpb.ListDashboardBalanceRequest', null, global);
goog.exportSymbol('proto.reportpb.ListDashboardBalanceResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.Balance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.Balance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.Balance.displayName = 'proto.reportpb.Balance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListBalanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ListBalanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListBalanceRequest.displayName = 'proto.reportpb.ListBalanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListBalanceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.reportpb.ListBalanceResponse.repeatedFields_, null);
};
goog.inherits(proto.reportpb.ListBalanceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListBalanceResponse.displayName = 'proto.reportpb.ListBalanceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListCashBalanceSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ListCashBalanceSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListCashBalanceSummary.displayName = 'proto.reportpb.ListCashBalanceSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.DashboardBalance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.DashboardBalance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.DashboardBalance.displayName = 'proto.reportpb.DashboardBalance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListDashboardBalanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ListDashboardBalanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListDashboardBalanceRequest.displayName = 'proto.reportpb.ListDashboardBalanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListDashboardBalanceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.reportpb.ListDashboardBalanceResponse.repeatedFields_, null);
};
goog.inherits(proto.reportpb.ListDashboardBalanceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListDashboardBalanceResponse.displayName = 'proto.reportpb.ListDashboardBalanceResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.Balance.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.Balance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.Balance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.Balance.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    correspondent: jspb.Message.getFieldWithDefault(msg, 2, ""),
    accountNo: jspb.Message.getFieldWithDefault(msg, 3, ""),
    subAccountNo: jspb.Message.getFieldWithDefault(msg, 4, ""),
    accountName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 6, ""),
    broker: jspb.Message.getFieldWithDefault(msg, 7, ""),
    type: jspb.Message.getFieldWithDefault(msg, 8, ""),
    dateType: jspb.Message.getFieldWithDefault(msg, 9, ""),
    date: (f = msg.getDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    rep: jspb.Message.getFieldWithDefault(msg, 12, ""),
    branch: jspb.Message.getFieldWithDefault(msg, 13, ""),
    marginType: jspb.Message.getFieldWithDefault(msg, 14, ""),
    accountStatus: jspb.Message.getFieldWithDefault(msg, 20, ""),
    tdCashBalance: jspb.Message.getFieldWithDefault(msg, 21, ""),
    tdShortMarketValue: jspb.Message.getFieldWithDefault(msg, 22, ""),
    tdLongMarketValue: jspb.Message.getFieldWithDefault(msg, 23, ""),
    tdEquity: jspb.Message.getFieldWithDefault(msg, 24, ""),
    tdAdjustedBalance: jspb.Message.getFieldWithDefault(msg, 25, ""),
    sdCashBalance: jspb.Message.getFieldWithDefault(msg, 26, ""),
    sdShortMarketValue: jspb.Message.getFieldWithDefault(msg, 27, ""),
    sdLongMarketValue: jspb.Message.getFieldWithDefault(msg, 28, ""),
    sdEquity: jspb.Message.getFieldWithDefault(msg, 29, ""),
    sdAdjustedBalance: jspb.Message.getFieldWithDefault(msg, 30, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.Balance}
 */
proto.reportpb.Balance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.Balance;
  return proto.reportpb.Balance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.Balance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.Balance}
 */
proto.reportpb.Balance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubAccountNo(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateType(value);
      break;
    case 11:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setRep(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setBranch(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarginType(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountStatus(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdCashBalance(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdShortMarketValue(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdLongMarketValue(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdEquity(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdAdjustedBalance(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdCashBalance(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdShortMarketValue(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdLongMarketValue(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdEquity(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdAdjustedBalance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.Balance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.Balance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.Balance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.Balance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSubAccountNo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDateType();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getBranch();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getMarginType();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getAccountStatus();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getTdCashBalance();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getTdShortMarketValue();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getTdLongMarketValue();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getTdEquity();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getTdAdjustedBalance();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getSdCashBalance();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getSdShortMarketValue();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getSdLongMarketValue();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getSdEquity();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getSdAdjustedBalance();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
};


/**
 * optional uint32 account_id = 1;
 * @return {number}
 */
proto.reportpb.Balance.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string correspondent = 2;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string account_no = 3;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string sub_account_no = 4;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getSubAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setSubAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string account_name = 5;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getAccountName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setAccountName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string master_account_no = 6;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string broker = 7;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string type = 8;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string date_type = 9;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getDateType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setDateType = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional google.type.Date date = 11;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.Balance.prototype.getDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 11));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.Balance} returns this
*/
proto.reportpb.Balance.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.Balance.prototype.hasDate = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string rep = 12;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getRep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setRep = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string branch = 13;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string margin_type = 14;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getMarginType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setMarginType = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string account_status = 20;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getAccountStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setAccountStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string td_cash_balance = 21;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getTdCashBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setTdCashBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string td_short_market_value = 22;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getTdShortMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setTdShortMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string td_long_market_value = 23;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getTdLongMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setTdLongMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string td_equity = 24;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getTdEquity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setTdEquity = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string td_adjusted_balance = 25;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getTdAdjustedBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setTdAdjustedBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string sd_cash_balance = 26;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getSdCashBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setSdCashBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string sd_short_market_value = 27;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getSdShortMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setSdShortMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string sd_long_market_value = 28;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getSdLongMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setSdLongMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string sd_equity = 29;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getSdEquity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setSdEquity = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string sd_adjusted_balance = 30;
 * @return {string}
 */
proto.reportpb.Balance.prototype.getSdAdjustedBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.Balance} returns this
 */
proto.reportpb.Balance.prototype.setSdAdjustedBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListBalanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListBalanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListBalanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListBalanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    correspondent: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accountNo: jspb.Message.getFieldWithDefault(msg, 2, ""),
    accountName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 4, ""),
    branch: jspb.Message.getFieldWithDefault(msg, 5, ""),
    rep: jspb.Message.getFieldWithDefault(msg, 6, ""),
    fromDate: (f = msg.getFromDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    toDate: (f = msg.getToDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    usrId: jspb.Message.getFieldWithDefault(msg, 9, 0),
    pagination: (f = msg.getPagination()) && proto_utilspb_pagination_pb.Pagination.toObject(includeInstance, f),
    dateType: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListBalanceRequest}
 */
proto.reportpb.ListBalanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListBalanceRequest;
  return proto.reportpb.ListBalanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListBalanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListBalanceRequest}
 */
proto.reportpb.ListBalanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBranch(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRep(value);
      break;
    case 7:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setFromDate(value);
      break;
    case 8:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setToDate(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUsrId(value);
      break;
    case 10:
      var value = new proto_utilspb_pagination_pb.Pagination;
      reader.readMessage(value,proto_utilspb_pagination_pb.Pagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListBalanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListBalanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListBalanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListBalanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBranch();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFromDate();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getToDate();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getUsrId();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto_utilspb_pagination_pb.Pagination.serializeBinaryToWriter
    );
  }
  f = message.getDateType();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional string correspondent = 1;
 * @return {string}
 */
proto.reportpb.ListBalanceRequest.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListBalanceRequest} returns this
 */
proto.reportpb.ListBalanceRequest.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_no = 2;
 * @return {string}
 */
proto.reportpb.ListBalanceRequest.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListBalanceRequest} returns this
 */
proto.reportpb.ListBalanceRequest.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string account_name = 3;
 * @return {string}
 */
proto.reportpb.ListBalanceRequest.prototype.getAccountName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListBalanceRequest} returns this
 */
proto.reportpb.ListBalanceRequest.prototype.setAccountName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string master_account_no = 4;
 * @return {string}
 */
proto.reportpb.ListBalanceRequest.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListBalanceRequest} returns this
 */
proto.reportpb.ListBalanceRequest.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string branch = 5;
 * @return {string}
 */
proto.reportpb.ListBalanceRequest.prototype.getBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListBalanceRequest} returns this
 */
proto.reportpb.ListBalanceRequest.prototype.setBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string rep = 6;
 * @return {string}
 */
proto.reportpb.ListBalanceRequest.prototype.getRep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListBalanceRequest} returns this
 */
proto.reportpb.ListBalanceRequest.prototype.setRep = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional google.type.Date from_date = 7;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ListBalanceRequest.prototype.getFromDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 7));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ListBalanceRequest} returns this
*/
proto.reportpb.ListBalanceRequest.prototype.setFromDate = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListBalanceRequest} returns this
 */
proto.reportpb.ListBalanceRequest.prototype.clearFromDate = function() {
  return this.setFromDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListBalanceRequest.prototype.hasFromDate = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.type.Date to_date = 8;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ListBalanceRequest.prototype.getToDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 8));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ListBalanceRequest} returns this
*/
proto.reportpb.ListBalanceRequest.prototype.setToDate = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListBalanceRequest} returns this
 */
proto.reportpb.ListBalanceRequest.prototype.clearToDate = function() {
  return this.setToDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListBalanceRequest.prototype.hasToDate = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional uint32 usr_id = 9;
 * @return {number}
 */
proto.reportpb.ListBalanceRequest.prototype.getUsrId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ListBalanceRequest} returns this
 */
proto.reportpb.ListBalanceRequest.prototype.setUsrId = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional utilspb.Pagination pagination = 10;
 * @return {?proto.utilspb.Pagination}
 */
proto.reportpb.ListBalanceRequest.prototype.getPagination = function() {
  return /** @type{?proto.utilspb.Pagination} */ (
    jspb.Message.getWrapperField(this, proto_utilspb_pagination_pb.Pagination, 10));
};


/**
 * @param {?proto.utilspb.Pagination|undefined} value
 * @return {!proto.reportpb.ListBalanceRequest} returns this
*/
proto.reportpb.ListBalanceRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListBalanceRequest} returns this
 */
proto.reportpb.ListBalanceRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListBalanceRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string date_type = 11;
 * @return {string}
 */
proto.reportpb.ListBalanceRequest.prototype.getDateType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListBalanceRequest} returns this
 */
proto.reportpb.ListBalanceRequest.prototype.setDateType = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.reportpb.ListBalanceResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListBalanceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListBalanceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListBalanceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListBalanceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    balancesList: jspb.Message.toObjectList(msg.getBalancesList(),
    proto.reportpb.Balance.toObject, includeInstance),
    summary: (f = msg.getSummary()) && proto.reportpb.ListCashBalanceSummary.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListBalanceResponse}
 */
proto.reportpb.ListBalanceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListBalanceResponse;
  return proto.reportpb.ListBalanceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListBalanceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListBalanceResponse}
 */
proto.reportpb.ListBalanceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.reportpb.Balance;
      reader.readMessage(value,proto.reportpb.Balance.deserializeBinaryFromReader);
      msg.addBalances(value);
      break;
    case 2:
      var value = new proto.reportpb.ListCashBalanceSummary;
      reader.readMessage(value,proto.reportpb.ListCashBalanceSummary.deserializeBinaryFromReader);
      msg.setSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListBalanceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListBalanceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListBalanceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListBalanceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBalancesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.reportpb.Balance.serializeBinaryToWriter
    );
  }
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.reportpb.ListCashBalanceSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Balance balances = 1;
 * @return {!Array<!proto.reportpb.Balance>}
 */
proto.reportpb.ListBalanceResponse.prototype.getBalancesList = function() {
  return /** @type{!Array<!proto.reportpb.Balance>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.reportpb.Balance, 1));
};


/**
 * @param {!Array<!proto.reportpb.Balance>} value
 * @return {!proto.reportpb.ListBalanceResponse} returns this
*/
proto.reportpb.ListBalanceResponse.prototype.setBalancesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.reportpb.Balance=} opt_value
 * @param {number=} opt_index
 * @return {!proto.reportpb.Balance}
 */
proto.reportpb.ListBalanceResponse.prototype.addBalances = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.reportpb.Balance, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.ListBalanceResponse} returns this
 */
proto.reportpb.ListBalanceResponse.prototype.clearBalancesList = function() {
  return this.setBalancesList([]);
};


/**
 * optional ListCashBalanceSummary summary = 2;
 * @return {?proto.reportpb.ListCashBalanceSummary}
 */
proto.reportpb.ListBalanceResponse.prototype.getSummary = function() {
  return /** @type{?proto.reportpb.ListCashBalanceSummary} */ (
    jspb.Message.getWrapperField(this, proto.reportpb.ListCashBalanceSummary, 2));
};


/**
 * @param {?proto.reportpb.ListCashBalanceSummary|undefined} value
 * @return {!proto.reportpb.ListBalanceResponse} returns this
*/
proto.reportpb.ListBalanceResponse.prototype.setSummary = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListBalanceResponse} returns this
 */
proto.reportpb.ListBalanceResponse.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListBalanceResponse.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListCashBalanceSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListCashBalanceSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListCashBalanceSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListCashBalanceSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    totalRows: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sdCashBalance: jspb.Message.getFieldWithDefault(msg, 2, ""),
    sdShortMarketValue: jspb.Message.getFieldWithDefault(msg, 3, ""),
    sdLongMarketValue: jspb.Message.getFieldWithDefault(msg, 4, ""),
    sdEquity: jspb.Message.getFieldWithDefault(msg, 5, ""),
    sdAdjustedBalance: jspb.Message.getFieldWithDefault(msg, 6, ""),
    sdMoneyMarket: jspb.Message.getFieldWithDefault(msg, 7, ""),
    moneyMarket: jspb.Message.getFieldWithDefault(msg, 8, ""),
    tdCashBalance: jspb.Message.getFieldWithDefault(msg, 9, ""),
    tdMoneyMarket: jspb.Message.getFieldWithDefault(msg, 10, ""),
    tdShortMarketValue: jspb.Message.getFieldWithDefault(msg, 11, ""),
    tdLongMarketValue: jspb.Message.getFieldWithDefault(msg, 12, ""),
    tdEquity: jspb.Message.getFieldWithDefault(msg, 13, ""),
    tdAdjustedBalance: jspb.Message.getFieldWithDefault(msg, 14, ""),
    tdDebitBalanceAge: jspb.Message.getFieldWithDefault(msg, 15, ""),
    sdDebitBalanceAge: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListCashBalanceSummary}
 */
proto.reportpb.ListCashBalanceSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListCashBalanceSummary;
  return proto.reportpb.ListCashBalanceSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListCashBalanceSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListCashBalanceSummary}
 */
proto.reportpb.ListCashBalanceSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalRows(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdCashBalance(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdShortMarketValue(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdLongMarketValue(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdEquity(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdAdjustedBalance(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdMoneyMarket(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMoneyMarket(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdCashBalance(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdMoneyMarket(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdShortMarketValue(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdLongMarketValue(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdEquity(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdAdjustedBalance(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdDebitBalanceAge(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdDebitBalanceAge(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListCashBalanceSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListCashBalanceSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListCashBalanceSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListCashBalanceSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalRows();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getSdCashBalance();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSdShortMarketValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSdLongMarketValue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSdEquity();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSdAdjustedBalance();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSdMoneyMarket();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMoneyMarket();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTdCashBalance();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getTdMoneyMarket();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTdShortMarketValue();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getTdLongMarketValue();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getTdEquity();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getTdAdjustedBalance();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getTdDebitBalanceAge();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getSdDebitBalanceAge();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional uint32 total_rows = 1;
 * @return {number}
 */
proto.reportpb.ListCashBalanceSummary.prototype.getTotalRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ListCashBalanceSummary} returns this
 */
proto.reportpb.ListCashBalanceSummary.prototype.setTotalRows = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string sd_cash_balance = 2;
 * @return {string}
 */
proto.reportpb.ListCashBalanceSummary.prototype.getSdCashBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListCashBalanceSummary} returns this
 */
proto.reportpb.ListCashBalanceSummary.prototype.setSdCashBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string sd_short_market_value = 3;
 * @return {string}
 */
proto.reportpb.ListCashBalanceSummary.prototype.getSdShortMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListCashBalanceSummary} returns this
 */
proto.reportpb.ListCashBalanceSummary.prototype.setSdShortMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string sd_long_market_value = 4;
 * @return {string}
 */
proto.reportpb.ListCashBalanceSummary.prototype.getSdLongMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListCashBalanceSummary} returns this
 */
proto.reportpb.ListCashBalanceSummary.prototype.setSdLongMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string sd_equity = 5;
 * @return {string}
 */
proto.reportpb.ListCashBalanceSummary.prototype.getSdEquity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListCashBalanceSummary} returns this
 */
proto.reportpb.ListCashBalanceSummary.prototype.setSdEquity = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string sd_adjusted_balance = 6;
 * @return {string}
 */
proto.reportpb.ListCashBalanceSummary.prototype.getSdAdjustedBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListCashBalanceSummary} returns this
 */
proto.reportpb.ListCashBalanceSummary.prototype.setSdAdjustedBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string sd_money_market = 7;
 * @return {string}
 */
proto.reportpb.ListCashBalanceSummary.prototype.getSdMoneyMarket = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListCashBalanceSummary} returns this
 */
proto.reportpb.ListCashBalanceSummary.prototype.setSdMoneyMarket = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string money_market = 8;
 * @return {string}
 */
proto.reportpb.ListCashBalanceSummary.prototype.getMoneyMarket = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListCashBalanceSummary} returns this
 */
proto.reportpb.ListCashBalanceSummary.prototype.setMoneyMarket = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string td_cash_balance = 9;
 * @return {string}
 */
proto.reportpb.ListCashBalanceSummary.prototype.getTdCashBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListCashBalanceSummary} returns this
 */
proto.reportpb.ListCashBalanceSummary.prototype.setTdCashBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string td_money_market = 10;
 * @return {string}
 */
proto.reportpb.ListCashBalanceSummary.prototype.getTdMoneyMarket = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListCashBalanceSummary} returns this
 */
proto.reportpb.ListCashBalanceSummary.prototype.setTdMoneyMarket = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string td_short_market_value = 11;
 * @return {string}
 */
proto.reportpb.ListCashBalanceSummary.prototype.getTdShortMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListCashBalanceSummary} returns this
 */
proto.reportpb.ListCashBalanceSummary.prototype.setTdShortMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string td_long_market_value = 12;
 * @return {string}
 */
proto.reportpb.ListCashBalanceSummary.prototype.getTdLongMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListCashBalanceSummary} returns this
 */
proto.reportpb.ListCashBalanceSummary.prototype.setTdLongMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string td_equity = 13;
 * @return {string}
 */
proto.reportpb.ListCashBalanceSummary.prototype.getTdEquity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListCashBalanceSummary} returns this
 */
proto.reportpb.ListCashBalanceSummary.prototype.setTdEquity = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string td_adjusted_balance = 14;
 * @return {string}
 */
proto.reportpb.ListCashBalanceSummary.prototype.getTdAdjustedBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListCashBalanceSummary} returns this
 */
proto.reportpb.ListCashBalanceSummary.prototype.setTdAdjustedBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string td_debit_balance_age = 15;
 * @return {string}
 */
proto.reportpb.ListCashBalanceSummary.prototype.getTdDebitBalanceAge = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListCashBalanceSummary} returns this
 */
proto.reportpb.ListCashBalanceSummary.prototype.setTdDebitBalanceAge = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string sd_debit_balance_age = 16;
 * @return {string}
 */
proto.reportpb.ListCashBalanceSummary.prototype.getSdDebitBalanceAge = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListCashBalanceSummary} returns this
 */
proto.reportpb.ListCashBalanceSummary.prototype.setSdDebitBalanceAge = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.DashboardBalance.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.DashboardBalance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.DashboardBalance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.DashboardBalance.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: (f = msg.getDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    tdCashBalance: jspb.Message.getFieldWithDefault(msg, 2, ""),
    tdMoneyMarket: jspb.Message.getFieldWithDefault(msg, 3, ""),
    tdShortMarketValue: jspb.Message.getFieldWithDefault(msg, 4, ""),
    tdLongMarketValue: jspb.Message.getFieldWithDefault(msg, 5, ""),
    tdEquity: jspb.Message.getFieldWithDefault(msg, 6, ""),
    tdAdjustedBalance: jspb.Message.getFieldWithDefault(msg, 7, ""),
    sdCashBalance: jspb.Message.getFieldWithDefault(msg, 8, ""),
    sdMoneyMarket: jspb.Message.getFieldWithDefault(msg, 9, ""),
    sdShortMarketValue: jspb.Message.getFieldWithDefault(msg, 10, ""),
    sdLongMarketValue: jspb.Message.getFieldWithDefault(msg, 11, ""),
    sdEquity: jspb.Message.getFieldWithDefault(msg, 12, ""),
    sdAdjustedBalance: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.DashboardBalance}
 */
proto.reportpb.DashboardBalance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.DashboardBalance;
  return proto.reportpb.DashboardBalance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.DashboardBalance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.DashboardBalance}
 */
proto.reportpb.DashboardBalance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdCashBalance(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdMoneyMarket(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdShortMarketValue(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdLongMarketValue(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdEquity(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTdAdjustedBalance(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdCashBalance(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdMoneyMarket(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdShortMarketValue(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdLongMarketValue(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdEquity(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdAdjustedBalance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.DashboardBalance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.DashboardBalance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.DashboardBalance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.DashboardBalance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getTdCashBalance();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTdMoneyMarket();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTdShortMarketValue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTdLongMarketValue();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTdEquity();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTdAdjustedBalance();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSdCashBalance();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSdMoneyMarket();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSdShortMarketValue();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getSdLongMarketValue();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getSdEquity();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getSdAdjustedBalance();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional google.type.Date date = 1;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.DashboardBalance.prototype.getDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 1));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.DashboardBalance} returns this
*/
proto.reportpb.DashboardBalance.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.DashboardBalance} returns this
 */
proto.reportpb.DashboardBalance.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.DashboardBalance.prototype.hasDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string td_cash_balance = 2;
 * @return {string}
 */
proto.reportpb.DashboardBalance.prototype.getTdCashBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.DashboardBalance} returns this
 */
proto.reportpb.DashboardBalance.prototype.setTdCashBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string td_money_market = 3;
 * @return {string}
 */
proto.reportpb.DashboardBalance.prototype.getTdMoneyMarket = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.DashboardBalance} returns this
 */
proto.reportpb.DashboardBalance.prototype.setTdMoneyMarket = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string td_short_market_value = 4;
 * @return {string}
 */
proto.reportpb.DashboardBalance.prototype.getTdShortMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.DashboardBalance} returns this
 */
proto.reportpb.DashboardBalance.prototype.setTdShortMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string td_long_market_value = 5;
 * @return {string}
 */
proto.reportpb.DashboardBalance.prototype.getTdLongMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.DashboardBalance} returns this
 */
proto.reportpb.DashboardBalance.prototype.setTdLongMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string td_equity = 6;
 * @return {string}
 */
proto.reportpb.DashboardBalance.prototype.getTdEquity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.DashboardBalance} returns this
 */
proto.reportpb.DashboardBalance.prototype.setTdEquity = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string td_adjusted_balance = 7;
 * @return {string}
 */
proto.reportpb.DashboardBalance.prototype.getTdAdjustedBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.DashboardBalance} returns this
 */
proto.reportpb.DashboardBalance.prototype.setTdAdjustedBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string sd_cash_balance = 8;
 * @return {string}
 */
proto.reportpb.DashboardBalance.prototype.getSdCashBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.DashboardBalance} returns this
 */
proto.reportpb.DashboardBalance.prototype.setSdCashBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string sd_money_market = 9;
 * @return {string}
 */
proto.reportpb.DashboardBalance.prototype.getSdMoneyMarket = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.DashboardBalance} returns this
 */
proto.reportpb.DashboardBalance.prototype.setSdMoneyMarket = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string sd_short_market_value = 10;
 * @return {string}
 */
proto.reportpb.DashboardBalance.prototype.getSdShortMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.DashboardBalance} returns this
 */
proto.reportpb.DashboardBalance.prototype.setSdShortMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string sd_long_market_value = 11;
 * @return {string}
 */
proto.reportpb.DashboardBalance.prototype.getSdLongMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.DashboardBalance} returns this
 */
proto.reportpb.DashboardBalance.prototype.setSdLongMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string sd_equity = 12;
 * @return {string}
 */
proto.reportpb.DashboardBalance.prototype.getSdEquity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.DashboardBalance} returns this
 */
proto.reportpb.DashboardBalance.prototype.setSdEquity = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string sd_adjusted_balance = 13;
 * @return {string}
 */
proto.reportpb.DashboardBalance.prototype.getSdAdjustedBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.DashboardBalance} returns this
 */
proto.reportpb.DashboardBalance.prototype.setSdAdjustedBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListDashboardBalanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListDashboardBalanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListDashboardBalanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListDashboardBalanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    fromDate: (f = msg.getFromDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    toDate: (f = msg.getToDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    period: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListDashboardBalanceRequest}
 */
proto.reportpb.ListDashboardBalanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListDashboardBalanceRequest;
  return proto.reportpb.ListDashboardBalanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListDashboardBalanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListDashboardBalanceRequest}
 */
proto.reportpb.ListDashboardBalanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setFromDate(value);
      break;
    case 2:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setToDate(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPeriod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListDashboardBalanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListDashboardBalanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListDashboardBalanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListDashboardBalanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFromDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getToDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getPeriod();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional google.type.Date from_date = 1;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ListDashboardBalanceRequest.prototype.getFromDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 1));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ListDashboardBalanceRequest} returns this
*/
proto.reportpb.ListDashboardBalanceRequest.prototype.setFromDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListDashboardBalanceRequest} returns this
 */
proto.reportpb.ListDashboardBalanceRequest.prototype.clearFromDate = function() {
  return this.setFromDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListDashboardBalanceRequest.prototype.hasFromDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.type.Date to_date = 2;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ListDashboardBalanceRequest.prototype.getToDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 2));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ListDashboardBalanceRequest} returns this
*/
proto.reportpb.ListDashboardBalanceRequest.prototype.setToDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListDashboardBalanceRequest} returns this
 */
proto.reportpb.ListDashboardBalanceRequest.prototype.clearToDate = function() {
  return this.setToDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListDashboardBalanceRequest.prototype.hasToDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string period = 3;
 * @return {string}
 */
proto.reportpb.ListDashboardBalanceRequest.prototype.getPeriod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListDashboardBalanceRequest} returns this
 */
proto.reportpb.ListDashboardBalanceRequest.prototype.setPeriod = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.reportpb.ListDashboardBalanceResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListDashboardBalanceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListDashboardBalanceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListDashboardBalanceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListDashboardBalanceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    dashboardBalancesList: jspb.Message.toObjectList(msg.getDashboardBalancesList(),
    proto.reportpb.DashboardBalance.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListDashboardBalanceResponse}
 */
proto.reportpb.ListDashboardBalanceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListDashboardBalanceResponse;
  return proto.reportpb.ListDashboardBalanceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListDashboardBalanceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListDashboardBalanceResponse}
 */
proto.reportpb.ListDashboardBalanceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.reportpb.DashboardBalance;
      reader.readMessage(value,proto.reportpb.DashboardBalance.deserializeBinaryFromReader);
      msg.addDashboardBalances(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListDashboardBalanceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListDashboardBalanceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListDashboardBalanceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListDashboardBalanceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDashboardBalancesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.reportpb.DashboardBalance.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DashboardBalance dashboard_balances = 1;
 * @return {!Array<!proto.reportpb.DashboardBalance>}
 */
proto.reportpb.ListDashboardBalanceResponse.prototype.getDashboardBalancesList = function() {
  return /** @type{!Array<!proto.reportpb.DashboardBalance>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.reportpb.DashboardBalance, 1));
};


/**
 * @param {!Array<!proto.reportpb.DashboardBalance>} value
 * @return {!proto.reportpb.ListDashboardBalanceResponse} returns this
*/
proto.reportpb.ListDashboardBalanceResponse.prototype.setDashboardBalancesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.reportpb.DashboardBalance=} opt_value
 * @param {number=} opt_index
 * @return {!proto.reportpb.DashboardBalance}
 */
proto.reportpb.ListDashboardBalanceResponse.prototype.addDashboardBalances = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.reportpb.DashboardBalance, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.ListDashboardBalanceResponse} returns this
 */
proto.reportpb.ListDashboardBalanceResponse.prototype.clearDashboardBalancesList = function() {
  return this.setDashboardBalancesList([]);
};


goog.object.extend(exports, proto.reportpb);
